export default {
  name: 'Anguilla',
  phonePattern: '12642351234',
  postalCodePattern: '',
  singlePostalCode: 'AI2640',
  postalCodeRegex: '^(AI2640)$',
  language: '',
  dobFormat: 'DD MM YY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/AI.js